exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "ul {\n  list-style-type: none;\n}\ndiv {\n  opacity: 1;\n}\ndiv:hover .dimonhover {\n  opacity: 0.8;\n}\n\n.testbg tr {\n  border: 10px solid blue;\n}", ""]);

